import { Reducer } from "redux";

import { SsoHppClaimsStatusResponse } from "../models/api/Referral";
import { SsoHppClaimsStatusUrlActionDispatchTypes } from "../constants/User";
import { UserPageTrackSsoHppClaimsStatusUrlActionTypes } from "../models/dispatchTypes/User";

const initialState: SsoHppClaimsStatusResponse = {
  loading: false,
  response: {
    ssoUrl: "",
    samlResponse: "",
    relayState: "",
  },
  error: null,
};

const GetSsoHppClaimsStatusReducer: Reducer<
  SsoHppClaimsStatusResponse,
  UserPageTrackSsoHppClaimsStatusUrlActionTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case SsoHppClaimsStatusUrlActionDispatchTypes.SSO_HPP_CLAIMS_STATUS_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case SsoHppClaimsStatusUrlActionDispatchTypes.SSO_HPP_CLAIMS_STATUS_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case SsoHppClaimsStatusUrlActionDispatchTypes.SSO_HPP_CLAIMS_STATUS_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case SsoHppClaimsStatusUrlActionDispatchTypes.SSO_HPP_CLAIMS_STATUS_RESET: {
      return initialState;
    }
  }
  return state;
};

export default GetSsoHppClaimsStatusReducer;
